import { Component, OnInit } from '@angular/core';
import Slider from '@shared/models/Slider';
import { JwtAuthService } from '@shared/services/auth/jwt-auth.service';

@Component({
  selector: 'app-product-sale',
  templateUrl: './product-sale.component.html',
  styleUrls: ['./product-sale.component.scss']
})
export class ProductSaleComponent implements OnInit {

  sliders: Slider[] = []

  constructor(private jwtAuthService: JwtAuthService) { }

  ngOnInit(): void {
    this.jwtAuthService.getSlider().subscribe(sliders => {
      this.extractSliders(sliders)
    })

    this.jwtAuthService.sliders$.subscribe(sliders => {
      this.extractSliders(sliders)
    })
  }

  extractSliders(sliders: Slider[]) {
    sliders = sliders || []
    this.sliders = sliders.filter(slider => slider.name.indexOf("SALE") >= 0)
  }

}
